import { Component, OnInit, ViewChild } from '@angular/core';
import { HistService } from 'src/app/hist/services/hist.service';
import { LoginUser } from 'src/app/permission/models/login-user';
import { BaseConfig } from 'src/app/services/base-config.service';
import { HcrService } from 'src/app/services/hcr-service.service';
import { LocalStoragesService } from 'src/app/services/local-storages.service';
import { ClinicEventHandler } from 'src/app/services/signalr-event-handler/clinic-event-handler';
import { ConsoleEventHandler } from 'src/app/services/signalr-event-handler/console-event-handler';
import { GroupMsgData, SignalRService } from 'src/app/services/signalr-service';
import { UserCache } from 'src/app/services/user-cache';

@Component({
  selector: 'app-report-remote',
  templateUrl: './report-remote.component.html',
  styleUrls: ['./report-remote.component.css']
})
export class ReportRemoteComponent implements OnInit {

  info:string = 'ReportRemoteComponent'
  env = '';
  serverConnection = ''
  localConnection = ''
  localMsg = ''
  loginMsg =''
  logs:string[] = []
  constructor(private hcrService:HcrService,
    private signalR:SignalRService,
    private localStorage:LocalStoragesService,
    private consoleEvt: ConsoleEventHandler,
    private bc:BaseConfig,
    private histService:HistService,
    
  ) { }
  private ws: WebSocket;
  ngOnInit() {
    this.env = window.location.host;
    //本機連線 完成取得電腦資訊
    this.hcrService.ConnectForBgPrint((d)=>{
      this.log('已建立背景本地連線')
      // 記錄下來 後續ConnectionAlive會用到
      this.localStorage.setItem('ConsoleInfo', d);
      this.signalR.startConnection(x=>{
        
        this.log('已建立背景遠端連線:'+this.signalR.Url+ ' ' +x);
        var u = UserCache.getLoginUser()
        this.loginMsg = `(${u.CompanyCode})${u.CompanyName} - (${u.Clinic.Code})${u.ClinicName}`
        // 加入推播接收
        this.signalR.consoleLogin(this.onMessage.bind(this))
        this.log('已開始監聽')
      },new ConsoleLogger((logLevel,message)=>{
        this.displayLog(`LogLevel: ${logLevel}, ${message}`)
        this.log(`LogLevel: ${logLevel}, ${message}`)
      }))
    },(e)=>{
      this.localMsg = JSON.stringify(e);
    });
    
    this.histService.Init();
    setInterval((x)=>{
      this.localConnection = '本機連線狀態：'+ (this.hcrService.ConnectStatus?'開':'關')
      this.serverConnection = '伺服連線狀態：' + this.signalR.State;
    },1000)
    setInterval(()=>{
      this.versionCheck()
    },60000)
  }
  async versionCheck(){
    var ver = BaseConfig.getConfig().version;
    await this.bc.loadConfig();
    var nVer = BaseConfig.getConfig().version;
    if(ver!=nVer){
      this.log('版本更新重整 ' + ver +' -> ' + nVer);
      window.location.reload()
    }
  }
  onMessage(data: GroupMsgData){
    this.log(JSON.stringify(data));
    this.displayLog(`Act:${data.Act}, Arg:${JSON.stringify(data.Arg)}`)
    this.consoleEvt.Invoke(data);
  }
  displayLog(msg:string){
    this.logs.push(msg)
    // 只顯示50筆
    this.logs = this.logs.filter((x,i)=>i> this.logs.length-50)
  }
  log(msg:string){
    if(window['chrome'].webview){
      window['chrome'].webview.postMessage({type:'log',data:msg});
    }
  }
}
export class ConsoleLogger implements signalR.ILogger{
  /**
   *
   */
  constructor(private fn:(logLevel: signalR.LogLevel, message: string)=>void) {
  }
  //fn:(logLevel: signalR.LogLevel, message: string)=>void;
  log(logLevel: signalR.LogLevel, message: string): void {
    this.fn(logLevel,message);
  }
}